import React from 'react';
import { Heart } from 'lucide-react';
import '../styles/GothicHeart.css';

const GothicHeart = ({ onClick }) => {
  return (
    <div className="love-heart-container">
      <button
        type="button"
        onClick={onClick}
        className="love-heart-trigger"
        aria-label="Mini Oyunları Aç"
        title="Mini Oyunlar 💕"
      >
        <Heart className="love-heart-icon" />
      </button>
    </div>
  );
};

export default GothicHeart;
